import { ApiOrderParams } from '@services/types';
import { VideoCallRecordingService } from '@services/videoCallRecordingService';
import { useQuery } from '@tanstack/react-query';

type UseVideoCallRecordingsParams = ApiOrderParams & {
  page: number;
  pageSize: number;
  courseId?: number;
};

export const useVideoCallRecordings = ({
  page,
  pageSize,
  courseId,
  orderField,
  orderDirection,
}: UseVideoCallRecordingsParams) => {
  return useQuery({
    queryKey: ['videoCallRecordings', page, pageSize, courseId, orderField, orderDirection],
    queryFn: () =>
      VideoCallRecordingService.getAll({
        page,
        pageSize,
        courseId,
        orderField,
        orderDirection,
      }),
  });
};
